/**
 * DatenschutzPage – Privacy Policy (Datenschutzerklärung)
 * Lab UI style.
 */

import { Link } from 'react-router-dom';

export default function DatenschutzPage() {
  return (
    <div className="lab-page">
      <div className="lab-orb lab-orb--1" />
      <div className="lab-orb lab-orb--2" />
      <div className="lab-orb lab-orb--3" />

      <section className="lab-hero" style={{ paddingBottom: '1rem' }}>
        <h1 className="lab-title" style={{ fontSize: '1.6rem' }}>
          SurrealEstate<span className="lab-title-accent">Lab</span>
        </h1>
      </section>

      <div className="lab-datenschutz-card">
        <Link to="/" className="lab-datenschutz-back">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
          Zurück zur Startseite
        </Link>

        <h2 style={{ fontSize: '1.35rem', marginTop: '1.5rem', marginBottom: '0.5rem' }}>Datenschutzerklärung</h2>

        <h2>1. Verantwortliche Stelle</h2>
        <p>
          WebPublicity<br />
          Etienne Fey<br />
          E-Mail: info@webpublicity.ch
        </p>

        <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
        <p>
          Beim Besuch unserer Website werden automatisch Informationen erfasst, die Ihr Browser an unseren Server sendet.
          Diese Informationen werden temporär in sogenannten Server-Logfiles gespeichert. Folgende Informationen werden
          dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
        </p>
        <ul>
          <li>IP-Adresse des anfragenden Rechners</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Name und URL der abgerufenen Datei</li>
          <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
          <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
        </ul>

        <h2>3. Registrierung und Nutzerkonto</h2>
        <p>
          Bei der Registrierung erheben wir Ihren Namen und Ihre E-Mail-Adresse. Diese Daten werden für die Kontoführung,
          die Personalisierung der Dienste und die Kommunikation mit Ihnen verwendet. Ihr Passwort wird verschlüsselt
          gespeichert und ist für uns nicht einsehbar.
        </p>

        <h2>4. Nutzung von KI-Diensten</h2>
        <p>
          SurrealEstateLab nutzt KI-Dienste (OpenAI, Google Gemini, xAI) zur Verarbeitung Ihrer Anfragen. Die an diese
          Dienste übermittelten Daten werden ausschliesslich zur Beantwortung Ihrer Anfrage verwendet und nicht für
          Trainingszwecke der KI-Modelle genutzt.
        </p>

        <h2>5. Kontaktformular</h2>
        <p>
          Wenn Sie uns über das Kontaktformular kontaktieren, werden Ihre Angaben (Name, E-Mail, Betreff, Nachricht)
          zur Bearbeitung Ihrer Anfrage gespeichert. Diese Daten werden nicht ohne Ihre Einwilligung weitergegeben.
        </p>

        <h2>6. Cookies</h2>
        <p>
          Unsere Website verwendet technisch notwendige Cookies für die Authentifizierung und Sitzungsverwaltung.
          Es werden keine Tracking-Cookies oder Cookies zu Werbezwecken eingesetzt.
        </p>

        <h2>7. Datensicherheit</h2>
        <p>
          Wir setzen technische und organisatorische Sicherheitsmassnahmen ein, um Ihre Daten gegen zufällige oder
          vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen.
          Die Datenübertragung erfolgt verschlüsselt über HTTPS.
        </p>

        <h2>8. Ihre Rechte</h2>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer
          personenbezogenen Daten. Kontaktieren Sie uns hierfür unter info@webpublicity.ch.
        </p>

        <h2>9. Änderungen</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
          Anforderungen entspricht.
        </p>

        <p className="lab-datenschutz-date">Zuletzt aktualisiert: Februar 2026</p>
      </div>
    </div>
  );
}
